module.exports = __webpack_public_path__ + "img/thirteenimg1.67a3258d.png";